export default "__VITE_ASSET__3359c04f__"